import InfiniteScroll from 'infinite-scroll'
import ObserveItem from './intersection-observer--item'

export default function () {

    const pagination = document.querySelector('.pagination__next')
    if (pagination) {
        const elem = document.querySelector('.article-list')
        const infScroll = new InfiniteScroll(elem, {
            // options
            path: '.pagination__next',
            append: '.article-list__item',
            hideNav: '.pagination',
            history: false
        })

        infScroll.on( 'append', function( response, path, items ) {
            items.forEach(item => {
                ObserveItem(item)
            })
        });
    }
}
